export const DEFAULT_LOADER_SIZE = '1rem';
export const DEFAULT_LOADER_POSITION = 'start';
